import {React, _} from 'utils';

export default function PointOfInterest({to, name}) {
	return (
		<div className="point-of-interest">
			<span className="label" data-link={to}><span>{_(name)}</span></span>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/modules/components/pointofinterest.js